import request from '@/utils/request'

// 首页数据
export function homeDataApi(query) {
  return request({
    url: '/api/content/index/index',
    method: 'get',
    params: query
  })
}

// 文章分类
export function articleClass(query) {
  return request({
    url: '/api/content/article/classify',
    method: 'get',
    params: query
  })
}

// 文章列表
export function articleList(query) {
  return request({
    url: '/api/content/article/list',
    method: 'get',
    params: query
  })
}

// 文章详情
export function articleInfo(data) {
  return request({
    url: '/api/content/article/info',
    method: 'post',
    data
  })
}

// 验证码
export function getCode(query) {
  return request({
    url: '/api/code',
    method: 'get',
    params: query
  })
}

// 商家入驻
export function merchantCheckIn(data) {
  return request({
    url: '/api/user/login/register',
    method: 'post',
    data,
  })
}

// 获取短信验证码
export function getSendSmsCode(data) {
  return request({
    url: '/api/user/login/sendSmsCode',
    method: 'post',
    data,
  })
}
